import React from 'react';

export default function MostraMotivo({ motivo, lang }) {

  switch (lang) {
    case 'pt':
      return mostraMotivoPt(motivo)
    case 'en':
      return mostraMotivoEn(motivo)
    case 'es':
      return mostraMotivoEs(motivo)
    default:
      break
  }

};

function mostraMotivoPt(motivo) {
  switch (motivo) {
    case 'elogio':
      return <div className="">Elogio</div>
    case 'sugestoes':
      return <div className="">Sugestões</div>
    case 'duvidas':
      return <div className="">Dúvidas</div>
    case 'solicitacoes':
      return <div className="">Solicitações</div>
    case 'denuncia':
      return <div className="">Denúncia</div>
    case 'reclamacao':
      return <div className="">Reclamação</div>
    default:
      break
  }
};

function mostraMotivoEn(motivo) {
  switch (motivo) {
    case 'elogio':
      return <div className="">Praise</div>
    case 'sugestoes':
      return <div className="">Suggestions</div>
    case 'duvidas':
      return <div className="">Doubts</div>
    case 'solicitacoes':
      return <div className="">Requests</div>
    case 'denuncia':
      return <div className="">Denunciation</div>
    case 'reclamacao':
      return <div className="">Complaint</div>
    default:
      break
  }
}

function mostraMotivoEs(motivo) {
  switch (motivo) {
    case 'elogio':
      return <div className="">Elogio</div>
    case 'sugestoes':
      return <div className="">Sugerencias</div>
    case 'duvidas':
      return <div className="">Dudas</div>
    case 'solicitacoes':
      return <div className="">Solicitudes</div>
    case 'denuncia':
      return <div className="">Denuncia</div>
    case 'reclamacao':
      return <div className="">Reclamo</div>
    default:
      break
  }
}